// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__3nome","tab":"UserNav_tab__3Aw7b"};